import React from 'react';
import PropTypes from 'prop-types';

import {
  ExtendedBox,
  Link,
  ModalWithOverlay,
} from '../../coreui';


class LearnMoreLink extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isVisible: false,
    };
    this.toggleVisible = this.toggleVisible.bind(this);
  }

  toggleVisible() {
    this.setState({
      isVisible: !this.state.isVisible,
    });
  }

  render() {
    return (
      <ExtendedBox>
        <Link
          type="L4"
          ml={10}
          onClick={this.toggleVisible}
        >
          Learn More
        </Link>
        <ModalWithOverlay
          isVisible={this.state.isVisible}
          handleClick={this.toggleVisible}
        >
          {this.props.content}
        </ModalWithOverlay>
      </ExtendedBox>
    );
  }
}

LearnMoreLink.propTypes = {
  content: PropTypes.string,
};

export default LearnMoreLink;
